module.exports = {
      id: "user-square-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#user-square",
      toString: function () {
        return this.url;
      }
    }